module.exports = __webpack_public_path__ + "assets/checkmark-blue-d5d51d.svg";